import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPrice = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 17,
	viewBox: "0 0 16 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_30537_10968)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M8 0.5C3.58867 0.5 0 4.08867 0 8.5C0 12.9113 3.58867 16.5 8 16.5C12.4113 16.5 16 12.9113 16 8.5C16 4.08867 12.4113 0.5 8 0.5ZM8 15.1667C4.324 15.1667 1.33333 12.176 1.33333 8.5C1.33333 4.824 4.324 1.83333 8 1.83333C11.676 1.83333 14.6667 4.824 14.6667 8.5C14.6667 12.176 11.676 15.1667 8 15.1667ZM10.6667 9.83333C10.6667 10.936 9.76933 11.8333 8.66667 11.8333V12.5C8.66667 12.8687 8.36867 13.1667 8 13.1667C7.63133 13.1667 7.33333 12.8687 7.33333 12.5V11.8333H7.15467C6.44333 11.8333 5.77933 11.4507 5.42267 10.834C5.238 10.5147 5.34733 10.1073 5.66533 9.92333C5.98467 9.73733 6.39267 9.848 6.576 10.166C6.69533 10.3727 6.91667 10.5 7.154 10.5H8.666C9.034 10.5 9.33267 10.2013 9.33267 9.83333C9.33267 9.58133 9.152 9.368 8.90333 9.32667L6.876 8.98867C5.98133 8.84 5.33267 8.07333 5.33267 7.16667C5.33267 6.064 6.23 5.16667 7.33267 5.16667V4.5C7.33267 4.132 7.63067 3.83333 7.99933 3.83333C8.368 3.83333 8.666 4.132 8.666 4.5V5.16667H8.84467C9.556 5.16667 10.22 5.55 10.5767 6.16667C10.7613 6.48533 10.652 6.89267 10.334 7.07733C10.014 7.262 9.60667 7.15267 9.42333 6.834C9.304 6.628 9.08267 6.50067 8.84533 6.50067H7.33333C6.96533 6.50067 6.66667 6.8 6.66667 7.16733C6.66667 7.41933 6.84733 7.63267 7.096 7.674L9.12333 8.012C10.018 8.16067 10.6667 8.92733 10.6667 9.834V9.83333Z",
			fill: "#333333"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_30537_10968",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "white",
			transform: "translate(0 0.5)"
		})
	}) })]
});
export default SvgPrice;
